import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionService } from '../../../services/session.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ParametroService } from '../../../services/parametro.service';

@Component({
	selector: 'factura-modal',
	templateUrl: './factura-modal.component.html',
    styleUrls: ['./factura-modal.component.css'],
    providers: [ParametroService]
})
export class FacturaModalComponent implements OnInit {
    @Input() public venta_id: String;
    public ruta_factura: String;
    public loading: boolean;

	constructor(
        private sanitizer: DomSanitizer,
        private ss: SessionService,
        public bsModalRef: BsModalRef,
        private parametroService: ParametroService,
    ) {
        this.ruta_factura = "";
        this.loading = false;

        //this.getRutaFactura();
	}

	ngOnInit() {
		//
    }

    /*getRutaFactura(){
        this.loading = true;
        let parametro_ruta_pdf_factura = 7;
        this.parametroService.getById(parametro_ruta_pdf_factura).subscribe(
            res => {
                this.ruta_factura = res.valor;
                this.loading = false;
            },
            err => {
                this.ruta_factura = "";
                this.loading = false;
            }
        );
    }*/
    
    endPoint(){
        let endpoint = this.ss.getData('host_api') + this.ss.getData('ruta_pdf_factura') + this.venta_id + "?dbname=" + this.ss.getData('dbname');
        return this.sanitizer.bypassSecurityTrustResourceUrl(endpoint);
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/factura-modal/factura-modal.component.ts